import { FilterMenuConfig } from '../../types/filter.type';

export const SPORT_FILTERS: FilterMenuConfig = {
  sortable: false,
  filters: [
    {
      type: 'radio',
      data: [
        {
          label: 'table.sport.running',
          value: 'running',
          icon: 'running',
        },
        {
          label: 'table.sport.cycling',
          value: 'cycling',
          icon: 'cycling',
        },
        {
          label: 'table.sport.rowing',
          value: 'rowing',
          icon: 'rowing',
        },
      ],
      unit: 'min',
    },
  ],
};
